import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLazyQuery } from "@apollo/client";
import { BsFileArrowDownFill } from "react-icons/bs";

import { GET_FORM_RESPONSES } from "../../GraphQl/Queries";
import { useParams } from "react-router-dom";
import { questionTypes } from "../../constants/QuestionType";
import { downloadFile } from "../../functions";
import "./Responses.css";
import Loader from "../Loader";

const Paragraph = (props) => {
  return (
    <div className='viewerFormBox' style={{ width: "100%" }}>
      <div className='viewerFormQuestionWrapper'>
        <div className='viewerQuestionTitle'>
          <span>{props.question?.questionTitle}</span>
          <span className='requiredStatus'>
            {props?.question?.required ? "*Required" : ""}
          </span>
        </div>
        <input
          type='text'
          value={props?.answer}
          className='viewerQuestionInput'
        />
      </div>
    </div>
  );
};
const LinearScale = (props) => {
  return (
    <div className='viewerFormBox' style={{ width: "100%" }}>
      <div className='viewerFormQuestionWrapper'>
        <div className='viewerQuestionTitle'>
          <span>{props?.question?.questionTitle}</span>
          <span className='requiredStatus'>
            {props?.question?.required ? "*Required" : ""}
          </span>
        </div>
        <div className='viewerQuestionBody flex items-center'>
          {Array(5)
            .fill(0)
            .map((input, idx) => (
              <>
                <div className='LinearScaleWrapper' key={idx}>
                  <input
                    type='radio'
                    name={props?.question?.questionTitle}
                    id={props?.question?.questionTitle + (idx + 1)}
                    className='linearScaleInput'
                    checked={parseInt(props?.answer) === idx + 1 ? true : false}
                    style={{ pointerEvents: "none" }}
                    // onChange={(e) => handleRes(idx + 1)}
                  />
                  <label
                    htmlFor={props?.question?.questionTitle + (idx + 1)}
                    className='linearScaleLabel'
                    style={{
                      background:
                        parseInt(props?.answer) === idx + 1 && "#007Bff",
                      color: parseInt(props?.answer) === idx + 1 && "#fff",
                    }}
                  >
                    {idx + 1}
                  </label>
                </div>
              </>
            ))}
        </div>
      </div>
    </div>
  );
};
const CheckBox = (props) => {
  return (
    <div className='viewerFormBox' style={{ width: "100%" }}>
      <div className='viewerFormQuestionWrapper'>
        <div className='viewerQuestionTitle'>
          <span>{props?.question?.questionTitle}</span>
          <span className='requiredStatus'>
            {props?.question?.required ? "*Required" : ""}
          </span>
        </div>
        {props?.question?.questionMetadata?.choices?.map((option, idx) => (
          <div className='choiceInputWrapper'>
            <input
              type='checkbox'
              className='ui-checkbox'
              name={props?.questionTitle + " " + props?.question?.id}
              value={option}
              id={option + props?.question?.id}
              checked={
                JSON.stringify(JSON.parse(props?.answer)).includes(option)
                  ? true
                  : false
              }
              style={{ pointerEvents: "none" }}
              // required={props?.question?.required}
              // onChange={(e) => handleRes(e)}
            />
            <label htmlFor={option + props?.question?.id}>{option}</label>
          </div>
        ))}
      </div>
    </div>
  );
};
const Radio = (props) => {
  return (
    <div className='viewerFormBox' style={{ width: "100%" }}>
      <div className='viewerFormQuestionWrapper'>
        <div className='viewerQuestionTitle'>
          <span>{props?.question?.questionTitle}</span>
          <span className='requiredStatus'>
            {props?.question?.required ? "*Required" : ""}
          </span>
        </div>
        {props?.question?.questionMetadata?.choices?.map((option) => (
          <div className='choiceInputWrapper'>
            <input
              type='radio'
              className='ui-checkbox ui-radio'
              name={props?.questionTitle + " " + props?.question?.id}
              value={option}
              id={option + props?.question?.id}
              checked={option === props?.answer ? true : false}
              // style={{ pointerEvents: "none" }}
            />{" "}
            <label htmlFor={option + props?.question?.id}>{option}</label>
          </div>
        ))}
      </div>
    </div>
  );
};

const Range = (props) => {
  return (
    <div className='viewerFormBox' style={{ width: "100%" }}>
      <div className='viewerQuestionTitle'>
        <span>{props?.question?.questionTitle}</span>
        <span className='requiredStatus'>
          {props?.question?.required ? "*Required" : ""}
        </span>
      </div>
      <div className='viewerFormQuestionWrapper'>
        <div class='range-input'>
          <input
            type='range'
            name={props?.question?.questionTitle}
            id={props?.question?.questionTitle}
            value={parseInt(props?.answer)}
            min={props?.question?.questionMetadata?.min}
            max={props?.question?.questionMetadata?.max}
          />
        </div>
        <div
          id={props?.question?.questionTitle + "range"}
          style={{ position: "absolute", right: "10%" }}
          className='rangeFormValue'
        >
          {props?.answer}
        </div>
      </div>
    </div>
  );
};

const Responses = () => {
  const state = useSelector((state) => state.allForms);
  const params = useParams();
  const [responses, setResponses] = useState([]);
  const [localResponse, setLocalResponse] = useState([]);
  const [localIdx, setLocalIdx] = useState(0);
  const [res, setRes] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [getResponses, { loading, data, error }] = useLazyQuery(
    GET_FORM_RESPONSES,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        getFormByIdAId: params?.id,
      },
      onCompleted: (data) => {
        setResponses(data?.getFormByIdA);
      },
    }
  );
  useEffect(() => {
    getResponses();
  }, []);
  useEffect(() => {
    setLocalResponse(responses?.responseDetails?.responses);

    setRes(responses?.responseDetails?.responses[localIdx]);
  }, [responses]);
  useEffect(() => {
    setRes(responses?.responseDetails?.responses[localIdx]);
  }, [localIdx]);
  useEffect(() => {
    setResponses(state?.currentForm?.responseDetails?.responses);
    setQuestions(state?.currentForm?.questions);
  }, [state]);

  return (
    <div className='' style={{ width: "90%" }}>
      {loading ? (
        <div
          className='viewerFormBox flex flex-row'
          style={{ width: "90%", margin: "0 auto" }}
        >
          <span className='fw-bold mx-5 text-lg'>
            <Loader />
            Loading..
          </span>
        </div>
      ) : (
        <>
          {responses?.responseDetails == null && (
            <div
              className='viewerFormBox flex flex-row'
              style={{ width: "100%" }}
            >
              <span className='fw-bold mx-5 text-lg'>
                No responses available !
              </span>
            </div>
          )}
          {!(responses?.length == 0 || responses?.responseDetails == null) && (
            <div className='responseTop d-flex items-center content-between'>
              <span>
                Now Viewing &nbsp;
                <input
                  type='number'
                  value={localIdx + 1}
                  onChange={(e) => setLocalIdx(e.target.value - 1)}
                  min={1}
                  max={responses?.responseDetails?.responses.length}
                />
                &nbsp; of &nbsp;
                {responses?.responseDetails?.responses.length}
              </span>
              <div className='d-flex '>
                <BsFileArrowDownFill
                  style={{
                    rotate: "90deg",
                    marginRight: "4px",
                    fontSize: "25px",
                  }}
                  color={"#007bff"}
                  onClick={(e) => {
                    if (localIdx == 0) setLocalIdx(0);
                    else setLocalIdx(localIdx - 1);
                  }}
                />
                <BsFileArrowDownFill
                  style={{ rotate: "-90deg", fontSize: "25px" }}
                  color={"#007bff"}
                  onClick={(e) => {
                    if (localIdx > responses?.responseDetails?.responses.length)
                      setLocalIdx(responses?.responseDetails?.responses.length);
                    else setLocalIdx(localIdx + 1);
                  }}
                />
              </div>
            </div>
          )}
          <>
            <div style={{ width: "100%" }}>
              {responses?.questions?.map((question, idx) => (
                <>
                  {res?.response
                    ?.filter(
                      (response) =>
                        response?.questionId == responses?.questions[idx]?.id
                    )
                    .map((res) => (
                      <>
                        {/* <div>{JSON.stringify(res)}</div> */}
                        <div>
                          {question?.questionType ===
                            questionTypes.PARAGRAPH && (
                            <Paragraph
                              question={question}
                              answer={res?.responseText}
                            />
                          )}
                          {question?.questionType ===
                            questionTypes.LINEAR_SCALE && (
                            <LinearScale
                              question={question}
                              answer={res?.responseText}
                            />
                          )}
                          {question?.questionType ===
                            questionTypes.CHECKBOX && (
                            <CheckBox
                              question={question}
                              answer={res?.responseText}
                            />
                          )}
                          {question?.questionType === questionTypes.RADIO && (
                            <Radio
                              question={question}
                              answer={res?.responseText}
                            />
                          )}
                          {question?.questionType === questionTypes.RANGE && (
                            <Range
                              question={question}
                              answer={res?.responseText}
                            />
                          )}
                        </div>
                      </>
                    ))}
                </>
              ))}
            </div>
          </>
        </>
      )}
    </div>
  );
};

export default React.memo(Responses);
